import { render, staticRenderFns } from "./InterconsultaPrincipal.vue?vue&type=template&id=46f5b0ef&"
import script from "./InterconsultaPrincipal.vue?vue&type=script&lang=js&"
export * from "./InterconsultaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports